import {BasicDataTable, BasicDataTableConfig, TypedColumnSettings} from "@/shared/ui/basicDataTable"
import {formatDate, isBeforeDay, parseISODate, Temporal} from "@/shared/utils/datefunctions";
import {Payment} from "@/shared/timr";

export class InvoiceDataTable extends BasicDataTable<Payment> {

	constructor(public config: BasicDataTableConfig) {
		super("/timr/account/invoices.json", config);
	}

	protected createDataTableConfig(): DataTables.Settings {
		return {
			dom: `rt<"datatable-footer"ip>`,
			rowCallback: (row, data, index) => {
				const payment = data as Payment;
				if (!payment.paid) {
					$(row).addClass("notPaid");
				}
			},
			pageLength: 15
		};
	}

	protected getColumnSettings(): TypedColumnSettings<Payment>[] {
		return [
			{data: "paymentDate", orderable: false, render: BasicDataTable.renderDate},
			{data: "amount", orderable: false, render: BasicDataTable.renderNumber, className: "text-right", width: "200px"},
			{data: "status", orderable: false, render: BasicDataTable.renderText},
			{data: "due", orderable: false, render: this.renderDueDate},
			{data: "id", orderable: false, render: this.renderInvoiceDownloadButton}
		];
	}

	protected getDefaultOrder(): (string | number)[][] {
		return [[0, "desc"]];
	}

	protected renderDueDate(this: void, data: string, type: string, row: Payment, meta: DataTables.CellMetaSettings): string {
		if (data) {
			const date = parseISODate(data);
			return formatDate(date) + (!row.paid && isBeforeDay(date, Temporal.Now.plainDateISO()) ? "⚠️" : "");
		} else {
			return "";
		}
	}

	protected renderInvoiceDownloadButton(this: void, data: number, type: string, row: Payment, meta: DataTables.CellMetaSettings): string {
		return "<a href='/timr/admin/invoices/download.html?paymentId=" + data + "' class='btn btn-default' ><i class='far fa-file-download'></i></a>";
	}

}
